import React, { useEffect, useRef, useState } from "react";
import {Link, Navigate, Outlet, useLocation } from "react-router-dom";
import Header from "../components/header";
import AdminSideBar2 from "../components/AdminSideBar2";
import { Nav } from "react-bootstrap";
import { Tooltip as ReactTooltip } from "react-tooltip";
import QuestionMarkSvg from "../assets/svg/QuestionMarkSvg";

const UseUi = () => {
  const [token, setToken] = useState(localStorage.getItem("tokenuser"));
  const [hide, setHide] = useState();
  const [Data, setData] = useState();
  const [togle, setTogle] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [showSettingMenu, setShowSettingMenu] = useState(false);
  const [showFunctions, setShowFunctions] = useState(false);
  const [hideBatchStatus, setHideBatchStatus] = useState(false);
  const [batchCount, setBatchCount] = useState(0);
  const [isTablet, setIsTablet] = useState(() => {
    const width = window.innerWidth;
    return width >= 768 && width <= 1024;
  });
  const [isMobileMenu, setIsMobileMenu] = useState(() => {
    return window.innerWidth <= 1024;
  });

  let Location = useLocation();
  let userId = JSON.parse(localStorage.getItem("tokenuser"));

  const getActiveMenuName = () => {
    const path = Location.pathname;
    if (path.includes("/selling")) return "Selling";
    if (path.includes("/buying")) return "Buying";
    if (path.includes("/pending")) return "Pending";
    if (path.includes("/history")) return "History";
    if (path.includes("/favorites")) return "Favourites";
    if (path.includes("/profile")) return "User Info";
    if (path.includes("/stripeconnectaccount")) return "Payments and Payouts";
    if (path.includes("/g2fa")) return "2FA";
    return "Menu";
  };

  const ref = useRef();
  const hideData = (data) => {
    setHide(data);
  };
  // Tablet and mobile menu detection
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsTablet(width >= 768 && width <= 1024);
      setIsMobileMenu(width <= 1024);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Listen for batch status updates from BuyingTab
  useEffect(() => {
    const handleBatchStatusUpdate = (e) => {
      setHideBatchStatus(e.detail.hideBatchStatus);
      setBatchCount(e.detail.batchCount);
    };

    window.addEventListener('batchStatusUpdate', handleBatchStatusUpdate);
    return () => window.removeEventListener('batchStatusUpdate', handleBatchStatusUpdate);
  }, []);

  useEffect(() => {
    let scrollWrapper = null;
    let tableContainer = null;
    let observer = null;
    let syncTimeout = null;
    let resizeHandler = null;
    let handleTableScroll = null;
    let handleHeaderScroll = null;
    let scrollTimeout = null;
    let maintainInterval = null;
    let rafId = null;
    let cloneRetryInterval = null;
    
    // Clone table header to mobile menu and sync scrolling
    const cloneTableHeader = () => {
      const tableHeader = document.querySelector('.managment-table thead, .graphic-table thead');
      const mobileHeader = document.getElementById('mobile-table-header');
      
      // Find the actual scrollable container - try multiple selectors
      const containers = [
        document.querySelector('.product_list_table.table-responsive'),
        document.querySelector('.managment-table')?.closest('.table-responsive'),
        document.querySelector('.graphic-table')?.closest('.table-responsive'),
        document.querySelector('.table-responsive'),
        document.querySelector('.product_list_table')
      ].filter(Boolean);
      
      tableContainer = containers[0];
      
      if (tableHeader && mobileHeader && tableContainer && window.innerWidth <= 1024) {
        // Clean up old listeners
        if (tableContainer && handleTableScroll) {
          tableContainer.removeEventListener('scroll', handleTableScroll);
        }
        if (scrollWrapper && handleHeaderScroll) {
          scrollWrapper.removeEventListener('scroll', handleHeaderScroll);
        }
        if (observer) {
          observer.disconnect();
        }
        if (syncTimeout) {
          clearTimeout(syncTimeout);
        }
        
        // Create scroll wrapper
        scrollWrapper = document.createElement('div');
        scrollWrapper.className = 'mobile-header-scroll';
        mobileHeader.innerHTML = '';
        const cloned = tableHeader.cloneNode(true);
        scrollWrapper.appendChild(cloned);
        mobileHeader.appendChild(scrollWrapper);
        
        // Scroll handlers with perfect synchronization
        let tableScrolling = false;
        let headerScrolling = false;
        let rafId = null;
        
        handleTableScroll = () => {
          if (scrollWrapper && tableContainer && !headerScrolling) {
            tableScrolling = true;
            const scrollPos = tableContainer.scrollLeft;
            
            // Cancel any pending animation frame
            if (rafId) {
              cancelAnimationFrame(rafId);
            }
            
            // Use requestAnimationFrame for smooth, immediate sync
            rafId = requestAnimationFrame(() => {
              scrollWrapper.scrollLeft = scrollPos;
              tableScrolling = false;
            });
          }
        };
        
        handleHeaderScroll = () => {
          if (tableContainer && scrollWrapper && !tableScrolling) {
            headerScrolling = true;
            const scrollPos = scrollWrapper.scrollLeft;
            
            // Cancel any pending animation frame
            if (rafId) {
              cancelAnimationFrame(rafId);
            }
            
            // Use requestAnimationFrame for smooth, immediate sync
            rafId = requestAnimationFrame(() => {
              tableContainer.scrollLeft = scrollPos;
              headerScrolling = false;
            });
          }
        };
        
        // Sync column widths with precise matching
        const syncColumnWidths = () => {
          if (tableContainer && mobileHeader && scrollWrapper) {
            const headerTable = mobileHeader.querySelector('table');
            const bodyTable = tableContainer.querySelector('.managment-table, .graphic-table');
            
            if (headerTable && bodyTable) {
              // Force layout recalculation
              bodyTable.offsetHeight;
              headerTable.offsetHeight;
              
              const headerCells = headerTable.querySelectorAll('th');
              const firstBodyRow = bodyTable.querySelector('tbody tr:first-child');
              
              if (firstBodyRow) {
                const bodyCells = firstBodyRow.querySelectorAll('td, th');
                
                // Match column widths precisely
                if (headerCells.length === bodyCells.length) {
                  // First pass: Match all styling properties
                  headerCells.forEach((headerCell, index) => {
                    if (bodyCells[index]) {
                      const bodyCell = bodyCells[index];
                      
                      // Get computed styles for both cells
                      const bodyStyle = window.getComputedStyle(bodyCell);
                      const headerStyle = window.getComputedStyle(headerCell);
                      
                      // Match all spacing properties exactly
                      headerCell.style.paddingLeft = bodyStyle.paddingLeft;
                      headerCell.style.paddingRight = bodyStyle.paddingRight;
                      headerCell.style.paddingTop = bodyStyle.paddingTop;
                      headerCell.style.paddingBottom = bodyStyle.paddingBottom;
                      
                      // Match border widths
                      headerCell.style.borderLeftWidth = bodyStyle.borderLeftWidth;
                      headerCell.style.borderRightWidth = bodyStyle.borderRightWidth;
                      headerCell.style.borderTopWidth = bodyStyle.borderTopWidth;
                      headerCell.style.borderBottomWidth = bodyStyle.borderBottomWidth;
                      
                      // Match border styles
                      headerCell.style.borderLeftStyle = bodyStyle.borderLeftStyle;
                      headerCell.style.borderRightStyle = bodyStyle.borderRightStyle;
                      headerCell.style.borderTopStyle = bodyStyle.borderTopStyle;
                      headerCell.style.borderBottomStyle = bodyStyle.borderBottomStyle;
                      
                      // Match border colors
                      headerCell.style.borderLeftColor = bodyStyle.borderLeftColor;
                      headerCell.style.borderRightColor = bodyStyle.borderRightColor;
                      
                      // Match box-sizing
                      headerCell.style.boxSizing = bodyStyle.boxSizing;
                      
                      // Match text alignment
                      headerCell.style.textAlign = bodyStyle.textAlign;
                      
                      // Match font properties for consistent rendering
                      headerCell.style.fontSize = bodyStyle.fontSize;
                      headerCell.style.fontFamily = bodyStyle.fontFamily;
                      headerCell.style.fontWeight = bodyStyle.fontWeight;
                      headerCell.style.letterSpacing = bodyStyle.letterSpacing;
                    }
                  });
                  
                  // Force reflow
                  headerTable.offsetHeight;
                  bodyTable.offsetHeight;
                  
                  // Second pass: Match widths after all styles are applied
                  headerCells.forEach((headerCell, index) => {
                    if (bodyCells[index]) {
                      const bodyCell = bodyCells[index];
                      
                      // Get actual rendered width after all styles are applied
                      const bodyRect = bodyCell.getBoundingClientRect();
                      const bodyWidth = bodyRect.width;
                      
                      // Set exact width
                      headerCell.style.width = bodyWidth + 'px';
                      headerCell.style.minWidth = bodyWidth + 'px';
                      headerCell.style.maxWidth = bodyWidth + 'px';
                    }
                  });
                  
                  // Force another reflow to apply widths
                  headerTable.offsetHeight;
                  
                  // Calculate total width from all cells after width updates
                  let totalWidth = 0;
                  bodyCells.forEach(cell => {
                    totalWidth += cell.getBoundingClientRect().width;
                  });
                  
                  // Ensure both tables have the same total width
                  headerTable.style.width = totalWidth + 'px';
                  headerTable.style.minWidth = totalWidth + 'px';
                  headerTable.style.maxWidth = totalWidth + 'px';
                  bodyTable.style.width = totalWidth + 'px';
                  bodyTable.style.minWidth = totalWidth + 'px';
                  bodyTable.style.maxWidth = totalWidth + 'px';
                  
                  // Match table border-collapse and spacing
                  const bodyTableStyle = window.getComputedStyle(bodyTable);
                  headerTable.style.borderCollapse = bodyTableStyle.borderCollapse;
                  headerTable.style.borderSpacing = bodyTableStyle.borderSpacing;
                  
                  // Match table layout
                  headerTable.style.tableLayout = bodyTableStyle.tableLayout;
                  
                  // Final reflow and scroll sync
                  requestAnimationFrame(() => {
                    headerTable.offsetHeight;
                    if (tableContainer && scrollWrapper) {
                      scrollWrapper.scrollLeft = tableContainer.scrollLeft;
                    }
                  });
                }
              }
            }
          }
        };
        
        // Set up scroll listeners immediately
        if (tableContainer && handleTableScroll) {
          tableContainer.addEventListener('scroll', handleTableScroll, { passive: true });
          // Also listen for scrollend event if available (for browsers that support it)
          if ('onscrollend' in tableContainer) {
            tableContainer.addEventListener('scrollend', () => {
              if (scrollWrapper && tableContainer) {
                scrollWrapper.scrollLeft = tableContainer.scrollLeft;
              }
            }, { passive: true });
          }
        }
        if (scrollWrapper && handleHeaderScroll) {
          scrollWrapper.addEventListener('scroll', handleHeaderScroll, { passive: true });
          // Also listen for scrollend event if available (for browsers that support it)
          if ('onscrollend' in scrollWrapper) {
            scrollWrapper.addEventListener('scrollend', () => {
              if (tableContainer && scrollWrapper) {
                tableContainer.scrollLeft = scrollWrapper.scrollLeft;
              }
            }, { passive: true });
          }
        }
        
        // Additional safeguard: Use a continuous sync interval to maintain position and column alignment
        maintainInterval = setInterval(() => {
          if (tableContainer && scrollWrapper && !tableScrolling && !headerScrolling) {
            // Sync scroll positions if they don't match (immediate correction)
            const tableScroll = tableContainer.scrollLeft;
            const headerScroll = scrollWrapper.scrollLeft;
            const scrollDiff = Math.abs(tableScroll - headerScroll);
            
            if (scrollDiff > 0.1) {
              // Always sync header to table (table is the source of truth)
              scrollWrapper.scrollLeft = tableScroll;
            }
            
            // Periodically re-sync column widths to ensure perfect alignment
            const headerTable = mobileHeader.querySelector('table');
            const bodyTable = tableContainer.querySelector('.managment-table, .graphic-table');
            if (headerTable && bodyTable) {
              const headerCells = headerTable.querySelectorAll('th');
              const firstBodyRow = bodyTable.querySelector('tbody tr:first-child');
              if (firstBodyRow) {
                const bodyCells = firstBodyRow.querySelectorAll('td, th');
                if (headerCells.length === bodyCells.length) {
                  // Check if any column widths or positions are misaligned
                  let needsResync = false;
                  headerCells.forEach((headerCell, index) => {
                    if (bodyCells[index]) {
                      const headerRect = headerCell.getBoundingClientRect();
                      const bodyRect = bodyCells[index].getBoundingClientRect();
                      const headerWidth = headerRect.width;
                      const bodyWidth = bodyRect.width;
                      
                      // Check width alignment (allow 1px tolerance for sub-pixel rendering)
                      if (Math.abs(headerWidth - bodyWidth) > 1) {
                        needsResync = true;
                      }
                      
                      // Check horizontal position alignment
                      if (index === 0) {
                        // First column: check if left edges align relative to containers
                        const containerRect = tableContainer.getBoundingClientRect();
                        const headerContainerRect = scrollWrapper.getBoundingClientRect();
                        const headerRelativeLeft = headerRect.left - headerContainerRect.left;
                        const bodyRelativeLeft = bodyRect.left - containerRect.left;
                        
                        if (Math.abs(headerRelativeLeft - bodyRelativeLeft) > 1) {
                          needsResync = true;
                        }
                      } else {
                        // Other columns: check spacing between columns
                        const prevHeaderRect = headerCells[index - 1].getBoundingClientRect();
                        const prevBodyRect = bodyCells[index - 1].getBoundingClientRect();
                        const headerSpacing = headerRect.left - prevHeaderRect.right;
                        const bodySpacing = bodyRect.left - prevBodyRect.right;
                        
                        if (Math.abs(headerSpacing - bodySpacing) > 1) {
                          needsResync = true;
                        }
                      }
                    }
                  });
                  
                  if (needsResync) {
                    syncColumnWidths();
                    // Re-sync scroll after column width update
                    requestAnimationFrame(() => {
                      if (tableContainer && scrollWrapper) {
                        scrollWrapper.scrollLeft = tableContainer.scrollLeft;
                      }
                    });
                  }
                }
              }
            }
          }
        }, 100);
        
        // Sync column widths after table is rendered
        syncTimeout = setTimeout(() => {
          syncColumnWidths();
          resizeHandler = () => {
            syncColumnWidths();
            // Re-sync scroll position after resize
            if (tableContainer && scrollWrapper) {
              scrollWrapper.scrollLeft = tableContainer.scrollLeft;
            }
          };
          window.addEventListener('resize', resizeHandler);
        }, 400);
        
        // Also sync when table data changes
        const tableBody = document.querySelector('.managment-table tbody, .graphic-table tbody');
        if (tableBody) {
          observer = new MutationObserver(() => {
            setTimeout(() => {
              syncColumnWidths();
              // Re-sync scroll position after data change
              if (tableContainer && scrollWrapper) {
                scrollWrapper.scrollLeft = tableContainer.scrollLeft;
              }
            }, 200);
          });
          observer.observe(tableBody, { childList: true, subtree: true });
        }
      } else if (mobileHeader) {
        mobileHeader.innerHTML = '';
      }
    };

    cloneTableHeader();

    // Retry cloning until the tables are rendered; stop once header exists.
    cloneRetryInterval = setInterval(() => {
      const mobileHeader = document.getElementById('mobile-table-header');
      const existingClonedTable = mobileHeader?.querySelector('table');
      const tableHeader = document.querySelector('.managment-table thead, .graphic-table thead');

      if (tableHeader && mobileHeader && !existingClonedTable && window.innerWidth <= 1024) {
        cloneTableHeader();
      }

      if (existingClonedTable || window.innerWidth > 1024) {
        clearInterval(cloneRetryInterval);
        cloneRetryInterval = null;
      }
    }, 500);

    const globalResizeHandler = () => {
      // Only resync widths/scroll on resize instead of fully re-cloning to avoid flicker
      const mobileHeader = document.getElementById('mobile-table-header');
      const scrollWrapperEl = mobileHeader?.querySelector('.mobile-header-scroll');
      if (!scrollWrapperEl) {
        cloneTableHeader();
      }
    };
    window.addEventListener('resize', globalResizeHandler);
    
    return () => {
      window.removeEventListener('resize', globalResizeHandler);
      if (resizeHandler) {
        window.removeEventListener('resize', resizeHandler);
      }
      if (syncTimeout) {
        clearTimeout(syncTimeout);
      }
      if (scrollTimeout) {
        clearTimeout(scrollTimeout);
      }
      if (tableContainer && handleTableScroll) {
        tableContainer.removeEventListener('scroll', handleTableScroll);
      }
      if (scrollWrapper && handleHeaderScroll) {
        scrollWrapper.removeEventListener('scroll', handleHeaderScroll);
      }
      if (observer) {
        observer.disconnect();
      }
      // Clear maintain scroll position interval
      if (maintainInterval) {
        clearInterval(maintainInterval);
      }
      // Clear clone retry interval
      if (cloneRetryInterval) {
        clearInterval(cloneRetryInterval);
      }
      // Cancel any pending animation frames
      if (rafId) {
        cancelAnimationFrame(rafId);
      }
    };
  }, [Location.pathname]);
  
  const HendleSerch = () => {};

  const htmlString =
  "<p class='tl_name'><strong>Why batch</strong><p class='inn-text'>If you only want to buy one item but would like to<br/> bid on multiple items to get the best deal this tool<br/> is for you!<p/><br/><strong>How it works</strong><p class='inn-text'>When any item in the batch sells to you, all of <br/> your existing bids on the other items in the batch<br/> will be automatically deactivated. This makes it<br/> safe for you to bid on many items without risking<br/> to purchase more than one item.</p><br/><strong>Instructions</strong><br/><p class='inn-text'><strong>Create Batch</strong><br/>1. Select the items you would like to Batch.<br/>2. Click batch (All selected items will be Batched).<br/><br/><strong>Remove items</strong><br/>1. Select items you would like to remove.<br/>2. Click batch (All selected items will be removed from Batch).<br/><br/><strong>Add Batch</strong><br/>1. Select items you would like to add.<br/>2. Click batch (All selected items will be added to Batch).</p>";

  const handleLinkClick = () => {
    setTogle(false);  
  };

  const getPageFunctions = () => {
    const path = Location.pathname;
    
    if (path.includes("/selling")) {
      return [
        { label: "Delete", action: "delete" },
        { label: "Make Active", action: "makeActive" },
        { label: "Make Inactive", action: "makeInactive" },
        { label: "Show Inactive", action: "showInactive" },
        { label: "Filter", action: "filter" }
      ];
    } else if (path.includes("/buying")) {
      return [
        { label: "Unbatch", action: "unbatch" },
        { label: "Batch", action: "batch" },
        { label: hideBatchStatus ? `Hide Batch (${batchCount || 0})` : `Show Batch (${batchCount || 0})`, action: "showBatch" },
        // { label: "Duplicate", action: "duplicate" },
        { label: "Delete", action: "delete" },
        { label: "Make Active", action: "makeActive" },
        { label: "Make Inactive", action: "makeInactive" },
        { label: "Show Inactive", action: "showInactive" },
        { label: "Filter", action: "filter" }
      ];
    } else if (path.includes("/pending")) {
      return [
        { label: "Ready to ship", action: "readyToShip" },
        { label: "Filter", action: "filter" }
      ];
    }
    return [];
  };

  const handleFunctionClick = (action) => {
    window.dispatchEvent(new CustomEvent('mobileFunction', { detail: { action } }));
  };

  return token ? (
    <>
      <Header hideData={hideData} />
      {/* Mobile Horizontal Menu */}
      <div 
        style={{
          display: isMobileMenu ? 'block' : 'none',
          // position: 'sticky', // This is causing the menu to not be sticky
          top: 0,
          width: '100%',
          backgroundImage: 'url("https://001.gpuwiz.com/userbuysellbgimg.webp")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          overflow: 'visible',
          paddingBottom: '10px'
        }}
      >
          <Nav className="mobile-nav-horizontal">
            <Link style={{ marginBottom: '20px'}} to="/buySellManagment/selling" onClick={handleLinkClick} className={Location.pathname == "/buySellManagment/selling" ? "active" : ""}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-house" viewBox="0 0 16 16">
                <path d="M8.707 1.5a1 1 0 0 0-1.414 0L.646 8.146a.5.5 0 0 0 .708.708L2 8.207V13.5A1.5 1.5 0 0 0 3.5 15h9a1.5 1.5 0 0 0 1.5-1.5V8.207l.646.647a.5.5 0 0 0 .708-.708L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.707 1.5ZM13 7.207V13.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V7.207l5-5 5 5Z" />
              </svg>
              Selling
            </Link>
            <Link style={{ marginBottom: '20px'}} to="/buySellManagment/buying" onClick={handleLinkClick} className={Location.pathname == "/buySellManagment/buying" ? "active" : ""}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-inbox-fill" viewBox="0 0 16 16">
                <path d="M4.98 4a.5.5 0 0 0-.39.188L1.54 8H6a.5.5 0 0 1 .5.5 1.5 1.5 0 1 0 3 0A.5.5 0 0 1 10 8h4.46l-3.05-3.812A.5.5 0 0 0 11.02 4H4.98zm-1.17-.437A1.5 1.5 0 0 1 4.98 3h6.04a1.5 1.5 0 0 1 1.17.563l3.7 4.625a.5.5 0 0 1 .106.374l-.39 3.124A1.5 1.5 0 0 1 14.117 13H1.883a1.5 1.5 0 0 1-1.489-1.314l-.39-3.124a.5.5 0 0 1 .106-.374l3.7-4.625z" />
              </svg>
              Buying
            </Link>
            <Link style={{ marginBottom: '20px'}} to="/buySellManagment/pending" onClick={handleLinkClick} className={Location.pathname == "/buySellManagment/pending" ? "active" : ""}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-person-fill" viewBox="0 0 16 16">
                <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1H3Zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" />
              </svg>
              Pending
            </Link>
            <Link style={{ marginBottom: '20px'}} to="/buySellManagment/history" onClick={handleLinkClick} className={Location.pathname == "/buySellManagment/history" ? "active" : ""}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-bank2" viewBox="0 0 16 16">
                <path d="M8.277.084a.5.5 0 0 0-.554 0l-7.5 5A.5.5 0 0 0 .5 6h1.875v7H1.5a.5.5 0 0 0 0 1h13a.5.5 0 1 0 0-1h-.875V6H15.5a.5.5 0 0 0 .277-.916l-7.5-5zM12.375 6v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zm-2.5 0v7h-1.25V6h1.25zM8 4a1 1 0 1 1 0-2 1 1 0 0 1 0 2zM.5 15a.5.5 0 0 0 0 1h15a.5.5 0 1 0 0-1H.5z" />
              </svg>
              History
            </Link>
            <Link style={{ marginBottom: '20px'}} to="/buySellManagment/favorites" onClick={handleLinkClick} className={Location.pathname == "/buySellManagment/favorites" ? "active" : ""}>
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-suit-heart-fill" viewBox="0 0 16 16">
                <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" />
              </svg>
              Favourites
            </Link>
            <div className="mobile-setting-wrapper">
              <button className={`mobile-setting-toggle ${showSettingMenu ? 'active' : ''}`} onClick={() => setShowSettingMenu(!showSettingMenu)}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-tag-fill" viewBox="0 0 16 16">
                  <path d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                </svg>
                Setting
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="currentColor" viewBox="0 0 16 16" style={{ marginLeft: "4px", transform: showSettingMenu ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }}>
                  <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
                </svg>
              </button>
              {showSettingMenu && (
                <div className="mobile-setting-dropdown">
                  <Link to={"/profile/" + userId?.id} onClick={() => { handleLinkClick(); setShowSettingMenu(false); }} className="mobile-setting-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-suit-heart-fill" viewBox="0 0 16 16">
                      <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" />
                    </svg>
                    User Info
                  </Link>
                  <Link to={"/stripeconnectaccount/" + userId?.id} onClick={() => { handleLinkClick(); setShowSettingMenu(false); }} className="mobile-setting-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-suit-heart-fill" viewBox="0 0 16 16">
                      <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" />
                    </svg>
                    Payments and Payouts
                  </Link>
                  <Link to="/g2fa" onClick={() => { handleLinkClick(); setShowSettingMenu(false); }} className="mobile-setting-item">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" className="bi bi-suit-heart-fill" viewBox="0 0 16 16">
                      <path d="M4 1c2.21 0 4 1.755 4 3.92C8 2.755 9.79 1 12 1s4 1.755 4 3.92c0 3.263-3.234 4.414-7.608 9.608a.513.513 0 0 1-.784 0C3.234 9.334 0 8.183 0 4.92 0 2.755 1.79 1 4 1z" />
                    </svg>
                    2FA
                  </Link>
                </div>
              )}
            </div>
          </Nav>

        {getPageFunctions().length > 0 && (
          <button className="mobile-show-functions-btn mb-2" onClick={() => setShowFunctions(!showFunctions)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" viewBox="0 0 16 16" style={{ marginRight: "6px", transform: showFunctions ? "rotate(180deg)" : "rotate(0deg)", transition: "0.3s" }}>
              <path fillRule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z"/>
            </svg>
            {showFunctions ? "Hide Functions" : "Show Functions"}
          </button>
        )}
        {showFunctions && getPageFunctions().length > 0 && (
          <div className="mobile-functions-grid">
            {getPageFunctions().map((func, index) => (
              <button
                key={index}
                className="mobile-function-btn"
                onClick={() => handleFunctionClick(func.action)}
              >
                {func.label === "Batch" && (
                  <>
                  <ReactTooltip
                  className="custom-tooltip_buy-sell"
                  anchorId="app-batch-buying-tab"
                  place="bottom"
                  content={
                    <div dangerouslySetInnerHTML={{ __html: htmlString }} />
                  }
                  style={{ textTransform: "none" }}
                />
                <QuestionMarkSvg/>
                </>
                )}
                {func.label}
              </button>
            ))}
          </div>
        )}
        {/* <div id="mobile-table-header" className="mobile-table-header"></div> */}
      </div>
      <div className="d-flex">
        {!isTablet && <AdminSideBar2 />}
        <div className="main-content">
          <Outlet ref={ref} data={Data} />
        </div>
      </div>
    </>
  ) : (
    <Navigate to="/" />
  );
};

export default UseUi;
